module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7137/images/default-avatar.png"